import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=c847c924&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=c847c924&prod&lang=stylus&scoped=true"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=c847c924&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c847c924",
  null
  
)

export default component.exports